import { useMemo } from 'react';
import { StoreDeal } from '../../../domain/entities/Store';
import { setRecentClickoutCookie } from '../../services/clickout';
import { ClickoutComponentSource } from '../../services/urls';
import useClickoutUrl, { RedirectSource } from '../clickoutUrl';
import useIsomorphicCurrentUrl from '../useIsomorphicCurrentUrl';

export type DealUrlProps = {
  deal: Pick<
    StoreDeal,
    | 'id'
    | 'couponCode'
    | 'isTracked'
    | 'sourceUrl'
    | 'kind'
    | 'status'
    | 'store'
  > & {
    title?: string;
  };
  storeUrl?: string;
  bodyCoupon: string | null;
  couponHash?: string;
  componentSource?: ClickoutComponentSource;
  showCouponOnDealPage?: boolean;
  currentUserId?: string;
  recommendationId?: string;
  queryId?: string;
};

const useDealUrl = ({
  deal,
  storeUrl,
  couponHash,
  componentSource,
  currentUserId,
  recommendationId,
  queryId,
}: DealUrlProps) => {
  const { id: dealId, couponCode, sourceUrl, isTracked } = deal;

  const { clickoutUrl } = useClickoutUrl(
    RedirectSource.Deal,
    {
      dealId,
      sourceUrl,
      storeUrl,
      isTracked,
      componentSource,
      recommendationId,
      queryId,
    },
    currentUserId || ''
  );
  let url: string = useIsomorphicCurrentUrl();

  if (couponCode) {
    url = `${url}#open-coupon`;
  }

  if (couponHash) {
    url = `${url}${couponHash}`;
  }

  const goToClickoutUrl = useMemo(
    () =>
      clickoutUrl
        ? () => {
            setRecentClickoutCookie();
            setTimeout(() => {
              window.location.assign(clickoutUrl);
            }, 100);
          }
        : null,
    [clickoutUrl]
  );

  return {
    url,
    clickoutUrl,
    goToClickoutUrl,
  };
};

export default useDealUrl;
